<template>
	<div class="container-md mh-100">
		<LayoutHeaderSection>
			<template #title>
				<LayoutTextSection text="Detalle del balance" :breadcrumb="true" />
			</template>
		</LayoutHeaderSection>
		<main class="pt-5 pb-10 pb-0 vstack gap-5">
			<CompanyCardMedium :company="balance.company" :balance="balance" v-if="balance?.company" />
			<LayoutTableMain title="Historial de movimientos" :results="results" :loading="loading" @goPage="goPage">
				<template #body>
					<BalanceTableRow v-for="data in results?.data" v-bind:key="data.id" :transaction="data" :currency="balance?.currency" />
				</template>
			</LayoutTableMain>
		</main>
	</div>
</template>

<script>
	import { ref, reactive, onMounted } from 'vue';
	import router from '@/router';
	import store from '@/store';
	import composableForm from '@/composables/form';
	import BalanceRepository from '@/repositories/modules/Balance';

	export default {
		props: {
			id: String
		},
		setup(props) {
			const { loading, catchError } = composableForm();
			const balance = ref(null);
			const results = ref({});
			const filters = reactive({
				orderBy: 'created_at',
				orderMethod: 'desc',
				take: 20,
				page: 1
			});

			const getBalance = async () => {
				await BalanceRepository.show(props.id).then((response) => {
					balance.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'home' });
				});
			}

			const getResults = async () => {
				loading.value = true;

				await BalanceRepository.transactions(props.id, filters).then((response) => {
					results.value = response.data;
				}).catch((e) => {
					catchError(e, true);
					router.push({ name: 'home' });
				});

				loading.value = false;
			}

			const getData = () => {
				getBalance();
				getResults();
			}

			const goPage = (page) => {
				filters.page = page;
				getResults();
			}

			onMounted(getData);

			return { loading, filters, balance, results, goPage, getData };
		}
	}
</script>